<template>
  <div>
    <h1>Articles waiting for Approval</h1>
    <div v-if="loading">Loading...</div>
    <div v-else-if="error">Error: {{ error }}</div>
    <ul v-else>
      <li v-for="article in articles" :key="article.id">
        <h2>{{ article.Title }}</h2>
        <p>Abstract: <i>{{ article.Abstract }}</i></p>
        <p>Author: {{ article.AuthorName }}</p>
        <p>Published on: {{ article.CreatedAt }}</p>
        <p>CID: <a :href="`https://ipfs.io/ipfs/${article.CID}`">{{ article.CID }}</a></p>
        <button @click="approveArticle(article.CID)" class="w3-button w3-blue" style="margin-right:10px;">Approve</button>
        <button @click="deleteArticle(article.CID)" class="w3-button w3-red">Reject & Delete</button>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import config from '../config';

export default {
  name: 'ArticleList',
  setup() {
    const articles = ref([]);
    const loading = ref(true);
    const error = ref(null);
    const token = sessionStorage.getItem("jwt");

    const fetchArticles = async () => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/admin/article/queue`, {
          method: "GET",
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${token}`, // Include JWT in the Authorization header
          },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch articles');
        }
        const data = await response.json();
        articles.value = data;
      } catch (err) {
        error.value = err.message;
      } finally {
        loading.value = false;
      }
    };

    const approveArticle = async (cid) => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/admin/article/approve/${cid}`, {
          method: 'PATCH',
          headers: {
            "Authorization": `Bearer ${token}`,
          }
        });
        if (!response.ok) {
          throw new Error('Failed to perform the action');
        }
        alert('Approved!');
        fetchArticles();
      } catch (err) {
        alert(`Error: ${err.message}`);
      }
    };

    const deleteArticle = async (cid) => {
      try {
        const response = await fetch(`${ config.apiBaseUrl }/admin/article/delete/${cid}`, {
          method: 'DELETE',
          headers: {
            "Authorization": `Bearer ${token}`,
          }
        });
        if (!response.ok) {
          throw new Error('Failed to perform the action');
        }
        alert('Article deleted successfully!');
        fetchArticles();
      } catch (err) {
        alert(`Error: ${err.message}`);
      }
    };

    onMounted(fetchArticles);

    return {
      articles,
      loading,
      approveArticle,
      deleteArticle,
      config,
      error
    };
  }
};
</script>

<style scoped>
/* Optional styling */
h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 1em;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1em;
}
</style>
